import { nextTick } from 'vue'
import { createI18n } from 'vue-i18n'
import { languageCodes } from '@/constants/locales.ts'
import en from '@/locales/en-US.json'

const options = {
  legacy: false,
  locale: window.localStorage.getItem('stdio_locale_language') ?? 'en-US',
  fallbackLocale: 'en-US',
  escapeParameterHtml: true,
  warnHtmlMessage: false,
  messages: {
    'en-US': en,
  },
}

const i18n = createI18n(options)

export function initI18n() {
  loadLocaleMessages(options.locale)
  return i18n
}

export async function setI18nLanguage(locale) {
  const newLang = languageCodes.includes(locale) ? locale : 'en-US'
  if (!i18n.global.availableLocales.includes(newLang)) {
    await loadLocaleMessages(newLang)
  }

  i18n.global.locale.value = newLang
  document.querySelector('html').setAttribute('lang', newLang?.slice(0, 2))
  window.localStorage.setItem('stdio_locale_language', newLang)
}

export async function loadLocaleMessages(locale) {
  const newLang = languageCodes.includes(locale) ? locale : 'en-US'
  // if the locale file is already there, then return without doing anything
  if (i18n.global.availableLocales.includes(newLang)) {
    return
  }
  // load locale messages with dynamic import
  const messages = await import(`../locales/${newLang}.json`)

  // set locale and locale message
  i18n.global.setLocaleMessage(newLang, messages.default)

  return nextTick()
}

export const global = i18n.global
